export default __webpack_public_path__ + "static/media/FlyingFrog16.95fe0d51.png";